import {
  type TutorialObjective,
  TutorialMessageColors
} from '@powerplay/core-minigames'
import { defineStore } from 'pinia'

export interface TutorialState {
  anne: {
    showAnne: boolean,
    isRight: boolean
  },
  mobile: boolean,
  tutorialMessage: {
    message: string,
    showMessage: boolean,
    color: TutorialMessageColors,
    yellowText: string,
    yellowTextSpecial: boolean,
    offset: boolean
  },
  objectives: TutorialObjective[],
  settings: boolean,
  showTutorialInfo: boolean,
  instructionBoxText: string,
  showInstructionBox: boolean,
  resultPoints: number,
  showRelease: boolean,
  showObjectives: boolean,
}

const initialState = (): TutorialState => ({
  anne: {
    showAnne: false,
    isRight: false
  },
  mobile: false,
  tutorialMessage: {
    message: '',
    showMessage: false,
    color: TutorialMessageColors.blank,
    yellowText: '',
    yellowTextSpecial: false,
    offset: false
  },
  settings: false,
  objectives: [],
  showTutorialInfo: false,
  instructionBoxText: '',
  showInstructionBox: false,
  resultPoints: 0,
  showRelease: false,
  showObjectives: true,
})

export const tutorialState = defineStore('tutorialState', {
  state: initialState,
})